import isEnumValue from '@orderna/admin-panel/src/utils/is-enum-value';

 /**
   * @deprecated Use TransactionSourceType or TransactionServiceType instead.
   */
export enum TransactionType {
  IN_STORE = 'in store',
  ONLINE = 'online',
  DELIVERY = 'delivery',
  PICK_UP = 'pick up',
  COUNTER = 'counter',
}

export const isTransactionType = (value: any) =>
  isEnumValue(TransactionType, value);
